import React, { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";

import { setHideBreadCrumb } from "../../../redux/features/hideBreadCrumb/hideBreadCrumb";
import { disableSwitcher } from "../../../redux/features/multiEntitySwitcher/multiEntitySwitcher";

import StatusContainer from "../../../components/_utils/CommonStatus/StatusContainer";
import TabsWeapperSection from "../../../components/_utils/CommonStatus/StatusSubComponents/TabsWrapperSection";
import InfoCard from "../../../components/_utils/CommonStatus/StatusSubComponents/StatusCardContainer/InfoCard";
import ICONS from "../../../assets/Icons";
import TEXT from "../../../utils/globalText";
import { GlobalConfiguration } from "../../../utils/configurationProvider";

const ChannelCreateError = () => {
  const { state } = useLocation();
  const location = useLocation();
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const isEditFlow = location.pathname.includes("/edit_channel_failed");

  const { createChannelError } = useSelector(
    (state) => state.notificationsSlice,
  );

  const extractErrorMessages = (errors) => {
    const messages = [];

    const recurse = (value) => {
      if (Array.isArray(value)) value.forEach(recurse);
      else if (typeof value === "object" && value !== null)
        Object.values(value).forEach(recurse);
      else if (typeof value === "string") messages.push(value);
    };

    recurse(errors);
    return messages;
  };

  const errorMessages = createChannelError
    ? extractErrorMessages(createChannelError)
    : extractErrorMessages(JSON.parse(sessionStorage.getItem("channel_error")));

  useEffect(() => {
    dispatch(setHideBreadCrumb({ hide: true }));
    dispatch(disableSwitcher());
    return () => {
      dispatch(setHideBreadCrumb({ hide: false }));
    };
  }, [dispatch]);

  const createChannelHandler = () => {
    navigate("/home/notification_dashboard/create_channel");
  };

  const dashboardHandler = () => {
    navigate("/home/notification_dashboard");
  };

  const buttonRows = [
    [
      {
        btnText: "Create channel",
        enabledBgColor: "var(--text-primary)",
        enabledTextColor: "var(--negative-bg)",
        icon: ICONS?.ADD_BUTTON_WHITE,
        handleFunction: createChannelHandler,
        iconToBeAlign: "left",
        fullWidthRequired: true,
        imgColor: "var(--negative-bg)",
        hoverOption: "dark",
      },

      {
        btnText: "Go to dashboard",
        enabledBgColor: "var(--negative-bg)",
        enabledTextColor: "var(--text-primary)",
        icon: ICONS.GO_TO_DASHBOARD,
        handleFunction: dashboardHandler,
        iconToBeAlign: "left",
        fullWidthRequired: true,
        outLineColor: "var(--text-primary)",
        imgColor: "var(--text-primary)",
        hoverOption: "dark",
      },
    ],
  ];

  return (
    <StatusContainer
      status="error"
      title={
        isEditFlow
          ? "Failed to update channel details. Try again later."
          : "Failed to create channel."
      }
      buttonRows={buttonRows}
      hoverOption="white"
    >
      <TabsWeapperSection title="Channel details">
        <div className="flex flex-col">
          {errorMessages.length > GlobalConfiguration?.lengthCheckZero ? (
            errorMessages.map((msg, index) => (
              <InfoCard
                key={index}
                bgColor="var(--negative-card)"
                rows={[
                  {
                    leftTitle: msg,
                    leftSubTitle: "Error message",
                  },
                ]}
              />
            ))
          ) : (
            <InfoCard
              bgColor="var(--negative-card)"
              variant="text"
              label={TEXT?.NOT_AVAILABLE}
              subLabel="Error message"
            />
          )}
        </div>
      </TabsWeapperSection>
    </StatusContainer>
  );
};

export default ChannelCreateError;
